import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

import Navbar from './components/common/Navbar';
import LandingPage from './pages/LandingPage';
import CataloguePage from './pages/CataloguePage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import LoginPage from './pages/LoginPage';
import OrdersPage from './pages/OrdersPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import ProductPage from './pages/ProductPage';
import OrangeMoneyConfirmPage from './pages/OrangeMoneyConfirmPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminOrders from './pages/admin/AdminOrders';
import AdminProducts from './pages/admin/AdminProducts';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user, isAdmin } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (!isAdmin) return <Navigate to="/" />;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/"                      element={<LandingPage />} />
        <Route path="/catalogue"             element={<CataloguePage />} />
        <Route path="/produit/:id"           element={<ProductPage />} />
        <Route path="/login"                 element={<LoginPage />} />
        <Route path="/panier"                element={<CartPage />} />
        <Route path="/suivi-commandes"       element={<OrderTrackingPage />} />
        <Route path="/checkout"              element={<PrivateRoute><CheckoutPage /></PrivateRoute>} />
        <Route path="/mes-commandes"         element={<PrivateRoute><OrdersPage /></PrivateRoute>} />
        <Route path="/paiement-orange-money" element={<PrivateRoute><OrangeMoneyConfirmPage /></PrivateRoute>} />
        <Route path="/admin"                 element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/produits"        element={<AdminRoute><AdminProducts /></AdminRoute>} />
        <Route path="/admin/commandes"       element={<AdminRoute><AdminOrders /></AdminRoute>} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ style: { background: '#fff', color: '#111', border: '1px solid #EDE9FE', borderRadius: 8 } }} />
          <AppRoutes />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
